import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import { useNavigate } from "react-router-dom";

function Team_Business_Retopup() {
  const { userId } = useSelector((state) => state.Auth);
    const jwt_token = sessionStorage.getItem("jwt_token");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let user = "0";
  const [referralApi, setreferralApi] = useState([]);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState("222111");
  const [todate, setTodate] = useState("");
  const [formdate, setFromdate] = useState("");
  //   const [current, setCurrent] = useState('')
  const [currentPage, setcurrentPage] = useState(1);

  const [listPerpage, setlistPerpage] = useState(10);
  const [currentPage2, setcurrentPage2] = useState(1);
  const [listPerpage2, setlistPerpage2] = useState(10);
  const [positionfilter, setpositionfilter] = useState("0");
  const [StatusFilter, setStatusFilter] = useState("2");

  //   let value = 2
  const referral_API = async () => {
    try {
      let responceRight = await API.post(
        `/TeamBusinessReportAdminRetopup`,
        {
          loginid: userId,
          UserId: search,
          fromdate: formdate,
          todate: todate,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("levelincome", responceRight?.data?.data);
      responceRight = responceRight?.data?.data[0];
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          Id: item.Package === null ? "" : item.Id,
          Package: item.Package === null ? "Grand Total" : `$ ${item.Package}`,
          TodayCount: item.TodayCount,
          TodayBusiness: `$ ${item.TodayBusiness}`,
          TotalCount: item.TotalCount,
          TotalBusiness: `$ ${item.TotalBusiness}`,
        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, [positionfilter, StatusFilter]);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const indexOfLastPost2 = currentPage2 * listPerpage2;
  const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2;
  const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost);
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage2,
    indexOfLastPost2
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "#", accessor: "Id" },
      { Header: "Package", accessor: "Package" },
      { Header: "Today(Count)", accessor: "TodayCount" },
      { Header: "Today(Business)", accessor: "TodayBusiness" },
      { Header: "Total(Count)", accessor: "TotalCount" },
      { Header: "Total(Business)", accessor: "TotalBusiness" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          <div className="container">
            {/* <!-- Inline Form --> */}
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-primary">
                  <div className="panel-heading">
                    <h4 className="panel-title">Today-Total Business (Retoup)</h4>
                  </div>
                  <div
                    className="panel-body table-rep-plugin"
                    style={{ padding: "8px", overflowY: "scroll" }}
                  >
                    <div className="col-md-12">
                      <div className="row">
                        <form className="ng-pristine ng-valid">
                          <div className="col-sm-2">
                            <input
                              className="form-control in-ip-1"
                              id="uid"
                              onChange={(e) => setSearch(e.target.value)}
                              name="uid"
                              value={search}
                              placeholder="Enter User Id"
                              type="text"
                            />
                          </div>
                          <div class="col-md-2">
                            <input
                              class="form-control in-ip-1"
                              onChange={(e) => setTodate(e.target.value)}
                              id="todate"
                              name="todate"
                              type="date"
                            />
                          </div>
                          <div class="col-md-2">
                            <input
                              class="form-control in-ip-1"
                              onChange={(e) =>
                                setFromdate(new Date(e.target.value))
                              }
                              id="fdate"
                              name="fdate"
                              type="date"
                            />
                          </div>
                          <div className="col-sm-2">
                            <input
                              type="button"
                              id="btnsearch"
                              onClick={() => referral_API()}
                              className="btn btn-sm btn-primary"
                              value="Search"
                            />
                          </div>
                        </form>
                      </div>
                      <div className="row">
                        <div className="panel-heading">
                          <h4 className="panel-title"></h4>
                        </div>
                        <div
                          className="table-responsive"
                          data-pattern="priority-columns"
                          style={{ maxHeight: "500px", overflow: "scroll" }}
                        >
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Team_Business_Retopup;